/**
 * 路口年度建设数量走势组件
 * zxw
 * 2024-08-12
 */

import React, { useEffect, useState } from 'react';
import DualAxes from '@ant-design/plots/es/components/dual-axes';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const ITYEC = (props) => {
    const [data, setData] = useState([]);

    /**
     * 根据mod获取路口统计报表数据
     * @param {*} mod 
     */
    const getData = (mod) => {
        const params = {
            'mod': mod,
        }
        $.ajax({
            url: `${CNF.api}report/intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON',success:function(data){
                if(data.res === 0){
                    if(data.dat.length>0){
                        setData(data.dat);
                    }
                }
            }
        })
    }

    useEffect(()=>{
        getData('ITYEC');
    },[]);

    const config = {
        data: data,
        width: (winWidth - 40) / 4,
        paddingTop: 20,
        paddingRight: 10,
        xField: (d)=>{return d.year + '年'},
        interaction: {
            tooltip: {
              crosshairsStroke: '#fff'
            }
        },
        title : {
            title: '年度建设数量',
            size: 12,
            style: {
                titleFontSize: 12,
                titleFill: '#fff',
                align: 'center',
            },
        },
        axis:{
            x: {
                line: true,
                lineLineWidth: 1,
                lineStroke: props.lineColor,
                tickStroke: props.lineColor,
                labelFill: '#fff',
                lineLineDash: [0,0],
                labelFontSize: 12,
                labelStroke: '#fff',
                labelFillOpacity: 1,
                tickStrokeOpacity: 1,
            },
            y: {
                line: true,
                lineLineWidth: 1,
                lineStroke: props.lineColor,
                lineLineDash: [0,0],
                labelFill: '#fff',
                labelStroke: '#fff',
                labelFontSize: 12,
                labelFillOpacity: 1,
                tickStroke: props.lineColor,
                tickStrokeOpacity: 1,
                gridStroke: props.lineColor,
                gridStrokeOpacity: 1,
                gridLineWidth: 1,
                gridLineDash: [0,0]
            }
        },
        children: [
            {
                type: 'line',
                yField: 'count',
                shapeField: 'smooth',
                style: {
                    stroke: '#44CCCC',
                    lineWidth: 2,
                },
                tooltip: {
                    title: (d) => {
                        return d.year + '年';
                    },
                    items: [{ field: 'count',name: '建设数量', valueFormatter: (count) => `${count}` + '个', }],
                }
            },
            {
                type: 'point',
                yField: 'count',
                sizeField: 4,
                style: {
                  stroke: '#44CCCC',
                  fill: '#fff',
                },
                axis: { y: false },
                tooltip: false,
              },
        ],
        animate: {
            enter: {
                type: 'pathIn',
                duration: 3000,
            },
        },
    };
    return <DualAxes width={'100%'} {...config} />
}

export default ITYEC;